<template>
  <form @submit.prevent="confirm()">
    <div>
      <div>
        <div class="form-group">
          <label for="numero">Numéro du matériel, unique</label>
          <input type="text" class="form-control" id="numero" v-model="materiel.nom" maxlength="50" required>
          <div class="invalid-feedback" v-if="materialExists" style="color: red;">
            Un materiel avec le même numéro existe déjà dans la base de données !
          </div>
        </div>

        <label for="arrondissement">Arrondissement de rattachement</label>
        <div v-for="(arr, value) in currentVille.arrondissements" v-bind:key="value">
            <div class="radio">
            <label>
              <input type="radio" name="arrondissement" v-bind:value="arr.id" v-model="materiel.arrondissement_id" required>
              {{arr.nom}}
            </label>
          </div>
        </div>

        <br/>
        <label for="type">Type de matériel</label>
        <div v-for="m in currentVille.materielsPermis" v-bind:key="m.id">
            <div class="radio">
            <label>
              <input type="radio" name="materielPermis" v-bind:value="m.nom" v-model="materiel.materielType" required>
              {{ m.nom }}
            </label>
          </div>
        </div>

      </div>

      <div class="buttons">
        <button class="btn btn-primary">Confirmer</button>
        <div class="btn btn-default" v-on:click="$emit('close')">
          Annuler
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  computed: {
    ...mapState([
      'currentUser',
      'arrondissements',
      'currentVille',
      'materiels'
    ]),
  },
  props: [
    'updateMateriel',

  ],
  data: function () {
    return {
      materiel: this.updateMateriel ? _.cloneDeep(this.updateMateriel) : {arrondissement_id: this.$store.state.currentVille.arrondissements[0].id,},
      materialExists: false,
    }
  },
  mounted () {
    this.$store.dispatch('fetchMaterielsByVilleId');
  },
  methods: {
    confirm: function () {

      this.materialExists =  this.materiels.data.find(
        (materiel) => materiel.nom === this.materiel.nom.trim() && materiel.id !== this.materiel.id
      )

      if (this.updateMateriel && !this.materialExists) {
        this.$store.dispatch('updateMateriel', this.materiel)
        this.$emit('close')
      } else if (!this.updateMateriel && !this.materialExists) {
        this.$store.dispatch('createMateriel', this.materiel)
        this.$emit('close')
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// MaterielForm.vue?f94c401c